import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=e0e0e3e8&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"
import style0 from "./branch.vue?vue&type=style&index=0&id=e0e0e3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e0e3e8",
  null
  
)

export default component.exports